import { render, staticRenderFns } from "./BlockSteam.vue?vue&type=template&id=33a09063&scoped=true&lang=pug"
import script from "./BlockSteam.vue?vue&type=script&lang=ts"
export * from "./BlockSteam.vue?vue&type=script&lang=ts"
import style0 from "./BlockSteam.vue?vue&type=style&index=0&id=33a09063&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a09063",
  null
  
)

export default component.exports